import { render, staticRenderFns } from "./InvoiceDataSection.vue?vue&type=template&id=521d679c&scoped=true&"
import script from "./InvoiceDataSection.vue?vue&type=script&lang=js&"
export * from "./InvoiceDataSection.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDataSection.vue?vue&type=style&index=0&id=521d679c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d679c",
  null
  
)

export default component.exports